import type { InjectionKey } from 'vue';
import type { FORM_ERROR } from '@pkg/sanity-utils/types/forms';

/**
 * Optional app-provided analytics for CMS forms.
 * Web wires Amplitude; business (and other hosts) may omit this.
 */
export type FormAnalyticsTracker = {
  trackFormError: (errorType: FORM_ERROR) => void;
};

export const formAnalyticsKey: InjectionKey<FormAnalyticsTracker> = Symbol('formAnalytics');
